export interface IApplicationService {
  hasAnyRole(allowedRoles: string[], existingRoles: string[]): boolean;
}

const ApplicationService = (): IApplicationService => {
  return {
    hasAnyRole(allowedRoles: string[], existingRoles: string[]): boolean {
      return existingRoles.some((role) => allowedRoles.includes(role));
    }
  };
};

export { ApplicationService };
